module.exports = __webpack_public_path__ + "img/pem_33.8d962d1a.png";